//Local
export const API_URL = 
//  "http://127.0.0.1:5001/api";
//Producción
 "https://skybotdhlback.skyangel.com.mx/api";

// Otras configuraciones
export const AVATAR_MODEL_PATH = '/models/avatar.glb';
export const SPEECH_TO_TEXT_API = '';
export const TEXT_TO_SPEECH_API = '';
